export default __webpack_public_path__ + "static/media/coffeeshop.349a7b50.svg";